var _mask, _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 62,
    viewBox: "0 0 87 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2190_2835",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6667 0C11.9391 0 0 11.9391 0 26.6667C0 41.3943 11.9391 53.3333 26.6667 53.3333H36.7532C36.8265 53.6123 36.9319 53.89 37.0719 54.1623L39.9429 59.747C41.4312 62.6419 45.5696 62.6418 47.0578 59.747L49.9288 54.1623C50.0688 53.89 50.1743 53.6123 50.2476 53.3333H60.3333C75.0609 53.3333 87 41.3943 87 26.6667C87 11.9391 75.0609 0 60.3333 0H26.6667Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6667 0C11.9391 0 0 11.9391 0 26.6667C0 41.3943 11.9391 53.3333 26.6667 53.3333H36.7532C36.8265 53.6123 36.9319 53.89 37.0719 54.1623L39.9429 59.747C41.4312 62.6419 45.5696 62.6418 47.0578 59.747L49.9288 54.1623C50.0688 53.89 50.1743 53.6123 50.2476 53.3333H60.3333C75.0609 53.3333 87 41.3943 87 26.6667C87 11.9391 75.0609 0 60.3333 0H26.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7532 53.3333L39.6547 52.571L39.0668 50.3333H36.7532V53.3333ZM37.0719 54.1623L39.74 52.7907L39.74 52.7907L37.0719 54.1623ZM39.9429 59.747L37.2749 61.1186V61.1186L39.9429 59.747ZM47.0578 59.747L44.3897 58.3753V58.3753L47.0578 59.747ZM49.9288 54.1623L47.2607 52.7907L47.2607 52.7907L49.9288 54.1623ZM50.2476 53.3333V50.3333H47.934L47.3461 52.571L50.2476 53.3333ZM3 26.6667C3 13.5959 13.5959 3 26.6667 3V-3C10.2822 -3 -3 10.2822 -3 26.6667H3ZM26.6667 50.3333C13.5959 50.3333 3 39.7374 3 26.6667H-3C-3 43.0511 10.2822 56.3333 26.6667 56.3333V50.3333ZM36.7532 50.3333H26.6667V56.3333H36.7532V50.3333ZM39.74 52.7907C39.6994 52.7117 39.6724 52.6383 39.6547 52.571L33.8516 54.0956C33.9805 54.5863 34.1644 55.0683 34.4039 55.534L39.74 52.7907ZM42.611 58.3753L39.74 52.7907L34.4039 55.534L37.2749 61.1186L42.611 58.3753ZM44.3897 58.3753C44.0177 59.0991 42.9831 59.0991 42.611 58.3753L37.2749 61.1186C39.8793 66.1846 47.1215 66.1846 49.7259 61.1186L44.3897 58.3753ZM47.2607 52.7907L44.3897 58.3753L49.7259 61.1186L52.5969 55.534L47.2607 52.7907ZM47.3461 52.571C47.3284 52.6383 47.3014 52.7117 47.2607 52.7907L52.5969 55.534C52.8363 55.0682 53.0202 54.5863 53.1491 54.0956L47.3461 52.571ZM60.3333 50.3333H50.2476V56.3333H60.3333V50.3333ZM84 26.6667C84 39.7374 73.4041 50.3333 60.3333 50.3333V56.3333C76.7178 56.3333 90 43.0511 90 26.6667H84ZM60.3333 3C73.4041 3 84 13.5959 84 26.6667H90C90 10.2822 76.7178 -3 60.3333 -3V3ZM26.6667 3H60.3333V-3H26.6667V3Z",
    fill: "#D1D5DB",
    mask: "url(#path-1-inside-1_2190_2835)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 27.6665,
    r: 2.5,
    fill: "#D1D5DB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 27.6665,
    r: 2.5,
    fill: "#D1D5DB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 27.6665,
    r: 2.5,
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoResult);
export default __webpack_public_path__ + "static/media/icon_noResult.1196703bd62cff50d23e76f2aae13832.svg";
export { ForwardRef as ReactComponent };